import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const TeaserWrapperImage = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  text-align: center;

  p {
    margin: 1em 0 0;
  }
`

const Image = ({ image, legend }) => {
  return (
    <TeaserWrapperImage>
      {image}
      {legend && <p>{legend}</p>}
    </TeaserWrapperImage>
  )
}

Image.propTypes = {
  image: PropTypes.element.isRequired,
  legend: PropTypes.string,
}

export { Image }
